import React, { useState, useEffect, useContext } from "react";
import { 
  Box, 
  Grid, 
  Typography, 
  makeStyles, 
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import { keys, values } from "lodash";
import { fbroot } from "../../firebase";
import ScrollToTop from "../../components/ScrollToTop";
import Filters from "./components/filters";
import Sorting from "./components/sorting";
import AlbumList from "../../components/AlbumList";
import useConfig from "../../hooks/useConfig";
import AccountContext from "../../contexts/AccountContext";
import AuthUserContext from "../../components/AuthUserContext";

const db = fbroot.database();

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    maxWidth: "90vw",
  },
  heading: {
    marginBottom: theme.spacing(3),
    zIndex: 2,
    position: "relative",
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(4),
    },
  },
  filters: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    justifyContent: "space-between",
    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-end",
    },
  },
  title: {
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
    },
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  albumSelector: {
    minWidth: 150,
    marginRight: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  }
}));

const AlbumsMember = () => {
  const classes = useStyles();
  const config = useConfig();
  const account = useContext(AccountContext);
  const user = useContext(AuthUserContext);

  const [loading, setLoading] = useState(false);
  const [albums, setAlbums] = useState({});
  const [filter, setFilter] = useState("all");
  const [filterCount, setFilterCount] = useState({});
  const [sort, setSort] = useState("date");
  const [viewMode, setViewMode] = useState("owner"); // "owner" or "user"

  // Initial fetch
  useEffect(() => {
    fetchAlbums();

    return () => {
      db.ref("catalog").off();
    };

    console.log(account)

  }, [account, viewMode]);

  // FILTER COUNT update
  useEffect(() => {
    const updateFilterCount = () => {
      const newFilterCount = values(albums).reduce(
        (totals, album) => {
          const category = getStatusCategory(album.status);

          if (!totals[category]) totals[category] = 0;

          totals[category] += 1;
          totals.all += 1;
          return totals;
        },
        { all: 0 }
      );

      setFilterCount(newFilterCount);
    };

    updateFilterCount();
  }, [albums]);

  /**
   * API Functions
   */

  // add/change album to state
  const toState = (snap) => {
    setAlbums((prev) => {
      return {
        ...prev,
        [snap.key]: snap.val(),
      };
    });

    setLoading(false);
  };

  const fetchAlbums = () => {
    if (!account?.owner_email || !user?.email) return;
    
    setLoading(true);
    
    // Clear previous listeners
    db.ref("catalog").off();
    
    // Clear albums
    setAlbums({});
    
    // Determine which email to use based on viewMode
    const targetEmail = viewMode === "owner" 
      ? account.owner_email.toLowerCase()
      : user.email.toLowerCase();
    
    // child added
    db.ref("catalog")
      .orderByChild("subaccount_user")
      .equalTo(targetEmail)
      .on("child_added", toState);

    // child changed
    db.ref("catalog")
      .orderByChild("subaccount_user")
      .equalTo(targetEmail)
      .on("child_changed", toState);
      
    // Also check for albums under the subaccount field
    db.ref("catalog")
      .orderByChild("subaccount")
      .equalTo(targetEmail)
      .on("child_added", toState);

    db.ref("catalog")
      .orderByChild("subaccount")
      .equalTo(targetEmail)
      .on("child_changed", toState);
      
    // Set a timeout to stop loading if it takes too long
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  };

  const getStatusCategory = (status) =>
    config.statuses[status]?.category || "other";

  const handleFilter = (choice) => {
    setFilter(choice);
  };

  const handleSort = (choice) => {
    setSort(choice);
  };

  const handleViewModeChange = (event) => {
    setViewMode(event.target.value);
  };

  // Only show the selector if we have different emails
  const showSelector = user?.email?.toLowerCase() !== account?.owner_email?.toLowerCase();

  return (
    <div className={classes.root}>
      <ScrollToTop />

      {/* Title and tools */}
      <div className={classes.heading}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <div className={classes.title}>
              {showSelector && (
                <FormControl variant="outlined" size="small" className={classes.formControl}>
                  {/* <InputLabel id="view-mode-label">Ver álbumes de</InputLabel> */}
                  <Select
                    labelId="view-mode-label"
                    id="view-mode-select"
                    value={viewMode}
                    onChange={handleViewModeChange}
                    // label="Ver álbumes de"
                  >
                    <MenuItem value="owner">{account.nameDisplay}</MenuItem>
                    <MenuItem value="user">Mis albums</MenuItem>
                  </Select>
                </FormControl>
              )}
              <Typography variant="h4">
                {keys(albums).length || 0} ÁLBUMS
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Box className={classes.filters}>
              <Filters
                selected={filter}
                filterCount={filterCount}
                onSelect={handleFilter}
              />

              <Sorting selected={sort} onSelect={handleSort} />
            </Box>
          </Grid>
        </Grid>
      </div>

      {/* Albums list */}
      <AlbumList
        albums={albums}
        loading={loading}
        filter={filter}
        sort={sort}
        getStatusCategory={getStatusCategory}
        initialPageSize={12}
        incrementSize={12}
      />
    </div>
  );
};

export default AlbumsMember;